export default "__VITE_ASSET__BJm5fGNC__"